import logo from "../../assets/Logo/BrainFlix-logo.svg";
import avatar from "../../assets/Images/Mohan-muruge.jpg";
import upload from "../../assets/Icons/upload.svg";
import "./Navbar.scss";
import { Link } from "react-router-dom";
import React from "react";
class Navbar extends React.Component {
  render() {
    return (
      <nav className="nav">
        <div className="nav__wrapper">
          <Link to="/">
            <img className="nav__logo" src={logo} alt="Brainflix" />
          </Link>
          <div className="search">
            <input
              className="input search__input"
              type="text"
              placeholder="Search"
            />
            <img className="search__avatar" src={avatar} alt="Mohan-muruge" />
            <Link to="/upload" className="search__btn">
              <button className="search__btn label-btn btn">
                <img className="btn__img" src={upload} alt="upload" />{" "}
                <span className="btn__text">upload</span>{" "}
              </button>
            </Link>
          </div>
        </div>
      </nav>
    );
  }
}

export default Navbar;
